import { atom } from 'jotai';

export const isTableItemDraggingState = atom(false);
